import { Container, TtfTextSceneObject } from '@cgs/wge';
import { T_Translations, Translations } from '@cgs/shared';
import { Popup } from '../../ui/popup/popup';
import { GameStateMachineNotifierComponent } from './game_state_machine_notifier_component';
import { T_GameStateMachineNotifierComponent } from '../../type_definitions';

const sceneIdToTranslationMap: Record<string, string> = {
  logo_no_balance_lbl: 'oops',
  no_balance_lbl: 'not-enough-balance',
  btg_lbl: 'back-to-game',
};

export const NOT_ENOUGH_BALANCE_POPUP_COMPONENT_TOKEN = Symbol(
  'NOT_ENOUGH_BALANCE_POPUP_COMPONENT_TOKEN'
);

export interface INotEnoughBalancePopupComponent {
  show(reloadOnClose?: boolean): void;
  hide(): void;
}

export class NotEnoughBalancePopupComponent implements INotEnoughBalancePopupComponent {
  private readonly container: Container;
  private readonly popup: Popup;
  private readonly notifierComponent: GameStateMachineNotifierComponent;

  constructor(container: Container) {
    this.container = container;
    this.popup = new Popup(container, {
      sceneId: 'bottom/notEnoughBalancePopup',
      animSceneId: 'Modes',
      showAnimState: 'show',
      hideAnimState: 'hide',
      closeButtonId: ['okBtn', 'fakeBTN'],
    });

    this.notifierComponent = container.resolve<GameStateMachineNotifierComponent>(
      T_GameStateMachineNotifierComponent
    );
  }

  public show(reloadOnClose: boolean = false): void {
    this.notifierComponent.notifier.notifyListenersEntered('popup');
    this.popup.show();
    this.applyTranslations();

    if (reloadOnClose) {
      this.popup.closed.once(() => location.reload());
    }
  }

  public hide(): void {
    this.notifierComponent.notifier.notifyListenersExited('popup');
    this.popup.hide();
  }

  private applyTranslations(): void {
    const translations = this.container.resolve<Translations>(T_Translations, { optional: true });

    if (!translations) {
      return;
    }

    Object.keys(sceneIdToTranslationMap).map((sceneId) => {
      const scenes = this.popup.findAllById<TtfTextSceneObject>(sceneId);
      const translation = translations.get(sceneIdToTranslationMap[sceneId]);

      if (scenes.length && translation) {
        scenes.forEach((scene) => (scene.text = translation));
      }
    });
  }
}
